const requireContext = require.context('./', false, /\.svg$/);

const icons = requireContext.keys().reduce((acc: Record<string, any>, filePath: string) => {
  const fileName = filePath.replace('./', '').replace('.svg', '');
  acc[fileName] = requireContext(filePath);
  return acc;
}, {});

console.log('Loaded SVG icons:', Object.keys(icons));

export default icons;